module.exports = __webpack_public_path__ + "resources/img/zoom_short_expiration_wildcard_licenses_partner_server.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/zoom_short_expiration_wildcard_licenses_partner_server.png
// module id = 1268
// module chunks = 0